export default __webpack_public_path__ + "content/media/21.ec501ad6.jpg";